import { Route, Routes } from "react-router-dom";

//pages
import Home from "./Pages/Home";
import Contact from "./Pages/Contact";
import About from "./Pages/About";
import Ventes from "./Pages/ventes";
import NotFound from "./Pages/NotFound";
import ProductInfo from "./Pages/ProductInfo.component";
import Login from "./Pages/Login.component";

//adminRoutes
import AdminHome from "./admin/pages/Home";
import GestionVente from "./admin/pages/GestionVente";
import AddEditProduct from "./admin/pages/AddEditProduct";
import CategoriePage from "./admin/pages/CategoriePage";

//Layout
import View from "./layouts/View";

//Auth
import ProtectedRoutes from "./Auth/ProtectedRoutes";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<View />}>
          <Route index element={<Home />}></Route>
          <Route path="contact" element={<Contact />}></Route>
          <Route path="ventes">
            <Route index element={<Ventes />}></Route>
            <Route path="produit/:id" element={<ProductInfo />}></Route>
          </Route>
          <Route path="about" element={<About />}></Route>
          <Route path="*" element={<NotFound />} />
          <Route path="login" element={<Login />}></Route>
        </Route>
        <Route path="/admin" element={<ProtectedRoutes />}>
          <Route index element={<AdminHome />}></Route>
          <Route path="gestionVente">
            <Route index element={<GestionVente />}></Route>
            <Route path="produit/:name" element={<AddEditProduct />}></Route>
            <Route path="categories" element={<CategoriePage />}></Route>
          </Route>

          <Route path="ajoutProduit" element={<AddEditProduct />}></Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
